import { Headset } from "lucide-react";
import { RECRUITER_PERK } from "@/lib/recruiter";

export const RecruiterPerk = ({ id }) => !RECRUITER_PERK[id] ? null : (
  <div className="mt-4 flex items-start gap-2 rounded-xl border border-[#8224e3]/50 bg-[#8224e3]/10 px-3 py-2 text-xs font-semibold text-[#e9d5ff] shadow-[0_0_18px_rgba(130,36,227,0.2)]" data-testid={`price-recruiter-${id}`}>
    <Headset className="mt-0.5 h-4 w-4 shrink-0 text-[#c79bff]" /><span>{RECRUITER_PERK[id]}<span className="block font-normal text-[10px] text-[#d7b6ff]/80">Included in the plan price</span></span>
  </div>
);
